import React, { useEffect, useState, useRef, useCallback } from "react";
import ReactConfetti from "react-confetti";
import {
  FaTrophy,
  FaStar,
  FaAward,
  FaCheckCircle,
  FaLightbulb,
  FaThumbsUp,
  FaChevronLeft,
  FaChevronRight,
  FaQuoteLeft,
  FaMedal,
  FaGlobeAsia,
  FaUsers,
} from 'react-icons/fa';
import "./Timeline.css";

/* ── Animated Counter Hook ── */
const useCounter = (target, duration = 1800) => {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  useEffect(() => {
    const obs = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      obs.disconnect();
      let start = 0;
      const step = target / (duration / 16);
      const tick = () => {
        start += step;
        if (start < target) { setCount(Math.floor(start)); requestAnimationFrame(tick); }
        else setCount(target);
      };
      requestAnimationFrame(tick);
    }, { threshold: 0.4 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [target, duration]);
  return [count, ref];
};

const AWARDS = [
  { year: "2006", title: "The Journey Begins",           description: "The inception of iMatrix Technologies, focusing on innovative tech solutions and establishing our core engineering values.",                   presentedBy: "Founding Team",              icon: <FaTrophy />,      tag: "Founding",     image: "/images/awards/1.png" },
  { year: "2007", title: "Excellence in Ts9 Rockers",    description: "Awarded for outstanding performance and contributions in the Ts9 Rockers initiative, showcasing early excellence.",                            presentedBy: "Ts9 Committee",              icon: <FaStar />,        tag: "Recognition",  image: "/images/awards/29.png" },
  { year: "2008", title: "Strategic Solutioning",        description: "Introduced strategic approaches to enhance service delivery and efficiency for growing enterprise needs.",                                     presentedBy: "Management Team",            icon: <FaStar />,        tag: "Strategy",     image: "/images/awards/21.png" },
  { year: "2009", title: "Achievers Award – H2 Topper",  description: "Recognized for achieving top performance in the H2 category, showcasing remarkable dedication and skill.",                                    presentedBy: "Dhruv Excellence",           icon: <FaCheckCircle />, tag: "Achievement",  image: "/images/awards/22.png" },
  { year: "2010", title: "Ballot Box Winner",            description: "Honored for securing the highest votes in the Ballot Box competition, showcasing exceptional popularity and trust.",                          presentedBy: "Ballot Box Org",             icon: <FaAward />,       tag: "Community",    image: "/images/awards/23.png" },
  { year: "2011", title: "TS9 Championship League",      description: "Awarded for winning the prestigious TS9 Championship League, demonstrating exceptional teamwork and excellence.",                             presentedBy: "TS9 Committee",              icon: <FaTrophy />,      tag: "Championship", image: "/images/awards/24.png" },
  { year: "2012", title: "Top 10 CP – South Zone",       description: "Recognized as one of the Top 10 Channel Partners in the South Zone for exceptional performance and contributions.",                          presentedBy: "iMatrix Pvt Ltd",            icon: <FaStar />,        tag: "Regional",     image: "/images/awards/25.png" },
  { year: "2013", title: "Evolution to Pvt Ltd",         description: "Transitioned to a Private Limited Company, significantly expanding our service portfolio and operational scale.",                            presentedBy: "Board of Directors",         icon: <FaCheckCircle />, tag: "Milestone",    image: "/images/awards/22.png" },
  { year: "2014", title: "5★ Partners Tally",            description: "Awarded the prestigious 5-Star Partner recognition for outstanding contributions to Tally solutions.",                                       presentedBy: "Tally Solutions",            icon: <FaAward />,       tag: "5-Star",       image: "/images/awards/23.png" },
  { year: "2015", title: "Best Performer Award",         description: "Awarded for outstanding individual performance and consistent excellence in achieving organizational goals.",                                 presentedBy: "Performance Council",        icon: <FaTrophy />,      tag: "Performance",  image: "/images/awards/24.png" },
  { year: "2016", title: "Nakshatra Achievers",          description: "Awarded for outstanding achievements and contributions in the field of technology and innovation.",                                          presentedBy: "Nakshatra Org",              icon: <FaStar />,        tag: "Innovation",   image: "/images/awards/25.png" },
  { year: "2017", title: "TSS Drive – Group Topper",     description: "Secured top position in the TSS Independence Day Drive for exceptional performance and commitment.",                                        presentedBy: "TSS Committee",              icon: <FaCheckCircle />, tag: "Leadership",   image: "/images/awards/26.png" },
  { year: "2018", title: "Top Trader Recognition",       description: "Recognized as a top trader for exceptional trading performance and consistent customer satisfaction.",                                       presentedBy: "National Trading Council",   icon: <FaTrophy />,      tag: "Trade",        image: "/images/awards/24.png" },
  { year: "2019", title: "High Value Contributor",       description: "Awarded for being the highest value contributor in key business domains across our service sectors.",                                        presentedBy: "Industry Leaders Forum",     icon: <FaStar />,        tag: "Value",        image: "/images/awards/25.png" },
  { year: "2020", title: "Highest TSS – Q3 5★",         description: "Recognized for achieving the highest TSS in Q3 and maintaining elite 5-star partnerships.",                                                  presentedBy: "iMatrix Technologies",       icon: <FaCheckCircle />, tag: "5-Star",       image: "/images/awards/26.png" },
  { year: "2021", title: "Customer Acquisition Elite",   description: "Honored for exceptional performance in acquiring and retaining valuable long-term enterprise customers.",                                    presentedBy: "Customer Excellence Council",icon: <FaAward />,       tag: "Growth",       image: "/images/awards/27.png" },
  { year: "2022", title: "TSS League Winner",            description: "Crowned the winner of the prestigious TSS Championship League for outstanding team performance.",                                           presentedBy: "TSS League Organizers",      icon: <FaTrophy />,      tag: "Championship", image: "/images/awards/28.png" },
  { year: "2023", title: "TSP Drive Best Performer",     description: "Recognized as the best performer in the TSP Drive for exceptional dedication and organizational results.",                                   presentedBy: "TSP Committee",              icon: <FaLightbulb />,   tag: "Performance",  image: "/images/awards/22.png" },
  { year: "2024", title: "Champion Excellence",          description: "Awarded for exemplary excellence in TP retail operations and achieving high-tier 5-star recognition.",                                      presentedBy: "TP Excellence Forum",        icon: <FaThumbsUp />,    tag: "Excellence",   image: "/images/awards/10.png" },
  { year: "2025", title: "Infinite Horizons",            description: "Achieved record milestones in customer acquisition and expanded our cloud solutions globally.",                                              presentedBy: "Global iMatrix Team",        icon: <FaAward />,       tag: "Milestone",    image: "/images/talent-acquisition-hr-manager-onboarding-new-employees_1036975-209046.avif" },
  { year: "2026", title: "Live & Ongoing Innovation",      description: "Driving next-generation AI integrations, expanding cloud accounting services, and delivering premium digital experiences.", presentedBy: "iMatrix Team",               icon: <FaLightbulb />,   tag: "Live Ongoing", image: "/images/tally-ira/tally-ira-logo.png" },
];

const HIGHLIGHTS = [
  { img: "/images/awards/21.png",  caption: "Strategic Excellence" },
  { img: "/images/awards/29.png",  caption: "Ts9 Rockers Award"   },
  { img: "/images/awards/3.png",   caption: "National Recognition" },
  { img: "/images/awards/10.png",  caption: "Champion 2024"       },
];

const STATS = [
  { value: 20, suffix: "+", label: "Years of Excellence",   icon: <FaStar /> },
  { value: 21, suffix: "",  label: "Awards & Accolades",    icon: <FaTrophy /> },
  { value: 5,  suffix: "★", label: "Tally Partner Tier",   icon: <FaMedal /> },
  { value: 5, suffix: "K+",label: "Customers Served",     icon: <FaUsers /> },
];

/* ── Stat Card ── */
const StatCard = ({ value, suffix, label, icon }) => {
  const [count, ref] = useCounter(value);
  return (
    <div className="stat-card" ref={ref}>
      <div className="stat-icon">{icon}</div>
      <div className="stat-number">{count}{suffix}</div>
      <div className="stat-label">{label}</div>
    </div>
  );
};

/* ── Award Card with scroll-reveal ── */
const SlideCard = ({ award, index }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { setVisible(true); obs.disconnect(); }
    }, { threshold: 0.12 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`timeline-slide-card ${visible ? 'card-visible' : ''}`}
      style={{ transitionDelay: `${Math.min(index * 0.04, 0.3)}s` }}
    >
      <div className="card-year-header">
        <span className="slide-year-badge">{award.year}</span>
        <span className="slide-tag">{award.tag}</span>
        <div className="slide-icon-box">{award.icon}</div>
      </div>
      <h3>{award.title}</h3>
      <p>{award.description}</p>
      <div className="slide-presented-by">
        <FaQuoteLeft className="quote-icon" />
        {award.presentedBy}
      </div>
      <div className="slide-image-box">
        <img src={award.image} alt={award.title} loading="lazy" />
      </div>
    </div>
  );
};

/* ── Main Timeline Component ── */
const Timeline = () => {
  const [isConfetti, setIsConfetti] = useState(false);
  const [activeYear, setActiveYear] = useState("2006");
  const [activeIdx, setActiveIdx] = useState(0);
  const scrollerRef = useRef(null);

  useEffect(() => {
    setIsConfetti(true);
    const timer = setTimeout(() => setIsConfetti(false), 6000);
    return () => clearTimeout(timer);
  }, []);

  const scrollToIndex = useCallback((idx) => {
    const scroller = scrollerRef.current;
    if (!scroller) return;
    const card = scroller.children[idx];
    if (card) {
      if (idx === AWARDS.length - 1) {
        scroller.scrollTo({ left: scroller.scrollWidth - scroller.clientWidth, behavior: 'smooth' });
      } else {
        scroller.scrollTo({ left: card.offsetLeft - 40, behavior: 'smooth' });
      }
      setActiveYear(AWARDS[idx].year);
      setActiveIdx(idx);
    }
  }, []);

  const handleScroll = useCallback(() => {
    const scroller = scrollerRef.current;
    if (!scroller) return;
    const sl = scroller.scrollLeft;
    
    const isAtEnd = Math.ceil(sl + scroller.clientWidth) >= scroller.scrollWidth - 15;
    const isAtStart = sl <= 15;
    
    let best = 0;
    if (isAtEnd) {
      best = AWARDS.length - 1;
    } else if (isAtStart) {
      best = 0;
    } else {
      let minD = Infinity;
      Array.from(scroller.children).forEach((child, i) => {
        const d = Math.abs(child.offsetLeft - 40 - sl);
        if (d < minD) { minD = d; best = i; }
      });
    }
    
    if (AWARDS[best]) {
      setActiveYear(AWARDS[best].year);
      setActiveIdx(best);
      const rail = document.querySelector(".year-selector-rail");
      if (rail) {
        const node = rail.querySelectorAll(".year-rail-node")[best];
        if (node) rail.scrollTo({ left: node.offsetLeft - rail.clientWidth / 2 + node.clientWidth / 2, behavior: 'smooth' });
      }
    }
  }, []);

  const nudgeLeft  = () => {
    const nextIdx = Math.max(0, activeIdx - 1);
    scrollToIndex(nextIdx);
  };
  const nudgeRight = () => {
    const nextIdx = Math.min(AWARDS.length - 1, activeIdx + 1);
    scrollToIndex(nextIdx);
  };

  return (
    <div className="timeline-page">

      {/* ── Confetti ── */}
      {isConfetti && (
        <div style={{ pointerEvents: 'none', position: 'fixed', inset: 0, zIndex: 99999 }}>
          <ReactConfetti width={window.innerWidth} height={window.innerHeight} opacity={0.65} recycle={false} />
        </div>
      )}

      {/* ── Decorative Background Orbs ── */}
      <div className="tl-orb tl-orb--top-right" aria-hidden="true" />
      <div className="tl-orb tl-orb--bottom-left" aria-hidden="true" />

      <div className="timeline-container">

        {/* ── Hero Header ── */}
        <header className="timeline-header">
          <div className="timeline-top-badge">
            <span className="badge-pulse" />
            A Legacy of Excellence · 2006 – 2026 (Ongoing)
          </div>
          <h1>Awards &amp; Accolades</h1>
          <p className="timeline-description">
            Celebrating nearly two decades of digital innovation, engineering excellence,
            and corporate leadership — a chronicle of our dedication to gold-standard enterprise solutions.
          </p>
        </header>

        {/* ── Animated Stats Row ── */}
        <div className="stats-row">
          {STATS.map((s, i) => <StatCard key={i} {...s} />)}
        </div>

        {/* ── Framed Highlights Gallery ── */}
        <section className="highlights-section">
          <div className="section-label">
            <span className="section-line" />
            Featured Highlights
            <span className="section-line" />
          </div>
          <div className="awards-highlight-grid">
            {HIGHLIGHTS.map(({ img, caption }, idx) => (
              <div className="highlight-card" key={idx}>
                <div className="highlight-frame-inner">
                  <img src={img} alt={caption} />
                </div>
                <div className="highlight-caption">{caption}</div>
              </div>
            ))}
          </div>
        </section>

        {/* ── Featured Spotlight ── */}
        <section className="spotlight-section">
          <div className="section-label">
            <span className="section-line" />
            20-Year Chronicle
            <span className="section-line" />
          </div>

          {/* ── Year Progress Rail ── */}
          <div className="year-selector-rail">
            <div className="year-rail-track">
              <div className="year-rail-progress" style={{ width: `calc(${activeIdx / (AWARDS.length - 1)} * (100% - 32px))` }} />
              {AWARDS.map((award, idx) => (
                <button
                  key={award.year}
                  className={`year-rail-node ${activeYear === award.year ? 'active' : ''} ${idx < activeIdx ? 'passed' : ''}`}
                  onClick={() => scrollToIndex(idx)}
                  aria-label={`Go to ${award.year}`}
                >
                  <span className="year-rail-dot" />
                  <span className="year-rail-text">{award.year}</span>
                </button>
              ))}
            </div>
          </div>

          {/* ── Active Card Summary Banner ── */}
          <div className="active-card-banner">
            <div className="acb-year">{activeYear}</div>
            <div className="acb-divider" />
            <div className="acb-body">
              <div className="acb-title">{AWARDS[activeIdx].title}</div>
              <div className="acb-sub">Presented by {AWARDS[activeIdx].presentedBy}</div>
            </div>
            <div className="acb-tag">{AWARDS[activeIdx].tag}</div>
            <div className="acb-nav">
              <button onClick={nudgeLeft}  className="acb-nav-btn" aria-label="Previous"><FaChevronLeft /></button>
              <span className="acb-counter">{activeIdx + 1} / {AWARDS.length}</span>
              <button onClick={nudgeRight} className="acb-nav-btn" aria-label="Next"><FaChevronRight /></button>
            </div>
          </div>

          {/* ── Horizontal Scroller ── */}
          <div className="timeline-slider-wrapper">
            <button className="scroller-nav-btn scroller-nav-btn--left"  onClick={nudgeLeft}  aria-label="Scroll left">
              <FaChevronLeft />
            </button>

            <div
              className="timeline-scroller-track"
              ref={scrollerRef}
              onScroll={handleScroll}
            >
              {AWARDS.map((award, index) => (
                <SlideCard key={index} award={award} index={index} />
              ))}
              {/* Easter Egg: Secret "???" card past the last milestone */}
              <div
                className="timeline-slide-card card-visible"
                style={{
                  opacity: 0.35,
                  filter: 'blur(2px)',
                  transition: 'opacity 0.5s, filter 0.5s',
                  cursor: 'default',
                  minWidth: 280,
                  userSelect: 'none',
                }}
                onMouseEnter={e => { e.currentTarget.style.opacity = 0.85; e.currentTarget.style.filter = 'blur(0px)'; }}
                onMouseLeave={e => { e.currentTarget.style.opacity = 0.35; e.currentTarget.style.filter = 'blur(2px)'; }}
              >
                <div className="card-year-header">
                  <span className="slide-year-badge" style={{ letterSpacing: '0.3em' }}>???</span>
                  <span className="slide-tag">Coming Soon</span>
                  <div className="slide-icon-box" style={{ fontSize: '1.4rem' }}>🚀</div>
                </div>
                <h3 style={{ color: 'var(--brand, #6b7a52)' }}>The Next Chapter</h3>
                <p style={{ fontStyle: 'italic', color: '#64748b' }}>
                  This chapter hasn't been written yet.
                  We're building it — with you.
                </p>
                <div className="slide-presented-by" style={{ marginTop: 12, color: '#94a3b8' }}>
                  <span style={{ fontSize: '0.8rem', letterSpacing: '0.05em' }}>— iMatrix Technologies, ongoing</span>
                </div>
              </div>

            </div>

            <button className="scroller-nav-btn scroller-nav-btn--right" onClick={nudgeRight} aria-label="Scroll right">
              <FaChevronRight />
            </button>
          </div>

        </section>

        {/* ── Bottom Quote CTA ── */}
        <div className="tl-cta-strip">
          <FaGlobeAsia className="cta-globe" />
          <div className="cta-strip-text">
            <h3>Trusted across industries for over 20 years</h3>
            <p>Join thousands of enterprises that rely on iMatrix for cutting-edge Tally, hardware, and IT solutions.</p>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Timeline;
